import { render, staticRenderFns } from "./PreviewAppBusiness.vue?vue&type=template&id=210d7776&scoped=true&"
import script from "./PreviewAppBusiness.vue?vue&type=script&lang=ts&"
export * from "./PreviewAppBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewAppBusiness.vue?vue&type=style&index=0&id=210d7776&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210d7776",
  null
  
)

export default component.exports